module.exports = __webpack_public_path__ + "static/media/2.5569edc5.jpg";